import {
  AssignableRecipientPagedList,
  AssignableRecipientPagedListResponse,
  RecipientAssignableListParams,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const recipientApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssignableRecipients: builder.query<AssignableRecipientPagedList, RecipientAssignableListParams>({
      query: (params) => ({
        url: 'Recipient/assignable',
        params,
      }),
      transformResponse: (response: AssignableRecipientPagedListResponse) => response.objectData,
    }),
  }),
});

export const { useGetAssignableRecipientsQuery } = recipientApi;
